import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: gray;
  padding: 0.25rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
`;
